import { ApiResponse, CustomQueryResponse } from "../../../../model/common/apiResponse";
import { axiosService, ServiceEndPoint } from "../../../../Services/common/Axios.service";

const SERVICE_URL=ServiceEndPoint.outbound_service;

export async function fetchShipmentsData(page?: number,payload?:any): Promise<ApiResponse<CustomQueryResponse<any>>> {
       const response = await axiosService.post(`${SERVICE_URL}shipments/query`,payload);
       return response.data;
}
export function recordCounts(status: string[],searchTerm:string,conditions:any,search_columns:any) {
    return {
      columns: [
        {
          data: "shipment.id",
          func: "count",
          as: "shipments_count"
        }
      ],
      conditions: [ ...conditions,
        ["shipment.status", "in", status]
      ],
      search_columns: search_columns,
      "search": searchTerm,
      
      limit: -1
    }
  }
export async function fetchStatusWiseCounts(statuses:string[],searchTerm:string,conditions:any,search_columns?:any): Promise<ApiResponse<any[]>> {
    const responses = await Promise.all(
        statuses.map(status => 
            axiosService.post(`${SERVICE_URL}shipments/query`, recordCounts([status],searchTerm,conditions,search_columns))
        )
    );
    const result = responses.reduce((acc: any, response, index) => {
        acc[statuses[index]] = response.data?.data?.results[0].shipments_count || 0;
        return acc;
    }, {});
    return { data: result };
}

export async function getShipmentDetails(id:string): Promise<ApiResponse<any>> {
    const response = await axiosService.get(`${SERVICE_URL}shipments/${id}`);
    return response.data;
}

export async function deallocateShipmentById(id: number): Promise<ApiResponse<any>> {
    const response = await axiosService.delete(`${SERVICE_URL}shipments/${id}`);
    return response.data;
}